const COPY = {
  en: {
    required: "* required",
    text: "We process your details to handle your enquiry (Art. 6(1)(b) and (f) GDPR). More in our ",
    link: "privacy policy",
    to: "/privacy" as const,
  },
  tr: {
    required: "* zorunlu alan",
    text: "Bilgilerinizi talebinizi yanıtlamak için işliyoruz (GDPR md. 6(1)(b) ve (f)). Ayrıntılar ",
    link: "gizlilik politikamızda",
    to: "/tr/gizlilik" as const,
  },
} as const;

export function RequiredFieldHint({ locale = "en" }: { locale?: "en" | "tr" }) {
  return <p className="mt-4 text-xs text-muted-foreground">{COPY[locale].required}</p>;
}

export function FormPrivacyNotice({ locale = "en" }: { locale?: "en" | "tr" }) {
  const copy = COPY[locale];
  return (
    <p className="mt-5 text-xs leading-relaxed text-muted-foreground">
      {copy.text}
      <a href={copy.to} className="font-semibold text-primary underline underline-offset-4">
        {copy.link}
      </a>
      .
    </p>
  );
}